import { render } from "./ChangeDocumentStatusModal.vue?vue&type=template&id=eab3ec28&ts=true"
import script from "./ChangeDocumentStatusModal.vue?vue&type=script&lang=ts"
export * from "./ChangeDocumentStatusModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__